export default __webpack_public_path__ + "static/media/branding-semibolditalic-webfont.6e679d30.woff2";